// enums/TicketStatus.ts
export enum TicketStatusEnum {
  CLOSED = "Closed",
}

export enum ReportType {
  SUMMARISED = "SUMMARISED",
  DETAILED = "DETAILED",
}
